import Vue from 'vue'
import Vuelidate from 'vuelidate'
// import { useVuelidate } from '@vuelidate/core'
Vue.use(Vuelidate)